import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface ToponomyMenuProps {
  visibility?: {
    circulationArea: boolean;
    territorialArea: boolean;
  };
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const ToponomyMenu = ({
  visibility = {
    circulationArea: true,
    territorialArea: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: ToponomyMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Tabelle Toponomastica" />
      </ListItem>
      <Menu
        id="ToponomyMenu-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {},
        }}
      >
        {visibility.circulationArea
          ? [
              <MenuItem
                onClick={(event: MouseEvent) => {
                  onClose(event);
                  navigate('/sistema/toponomastica/area-di-circolazione');
                }}
                key="circulation-area-menu-item"
              >
                <Typography variant="inherit">Gestione Aree di circolazione</Typography>
              </MenuItem>,
              <Divider key="circulation-area-divider" hidden={!visibility.circulationArea} />,
            ]
          : undefined}
        {visibility.territorialArea ? (
          <MenuItem
            onClick={(event) => {
              onClose(event);
              navigate('/sistema/toponomastica/ambiti-territoriali');
            }}
            key="ambiti-territoriali-menu-item"
          >
            <Typography variant="inherit">Aggiornamento Stradario e Ambiti Territoriali</Typography>
          </MenuItem>
        ) : undefined}
      </Menu>
    </Fragment>
  );
};

ToponomyMenu.displayName = 'Toponomy Menu';

export default ToponomyMenu;
